module.exports = __webpack_public_path__ + "static/media/back03.3f11b8a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/back03.jpg
// module id = 329
// module chunks = 0